const routes = {
  root: '/',
}

export default routes
